import React from "react";
import PropTypes from "prop-types";
import R from "ramda";
import { categoryType } from "custom-prop-types";
import { findIntegrationInUse, getIntegrationText } from "utils/check-integration";
import { SimpleSelect } from "components/common/select";

export const ExportTypeSelector = ({ categories, onChange }) => {
  const integrationStatus = findIntegrationInUse(categories);
  const integrationText = getIntegrationText(integrationStatus, "", "Accounting software");
  const newOptions = R.clone(options);
  newOptions[0].name = integrationText;
  return <SimpleSelect data={ newOptions } onChange={ onChange } placeholder="Select export type..." />;
};

ExportTypeSelector.propTypes = {
  categories: PropTypes.arrayOf(categoryType).isRequired,
  onChange: PropTypes.func.isRequired // ({ key: string, name: string}) => void
};

const options = [
  { disabled: true, key: "label2", name: "Accounting Software" },
  { key: "accounting", name: "Has been exported" },
  { key: "not-accounting", name: "Has not been exported" },

  { disabled: true, key: "label0", name: "CSV" },
  { key: "csv", name: "Has been exported to CSV" },
  { key: "not-csv", name: "Has not been exported to CSV" },

  { disabled: true, key: "label1", name: "PDF" },
  { key: "pdf", name: "Has been exported to PDF" },
  { key: "not-pdf", name: "Has not been exported to PDF" }
];

export const labelForExportType = (exportType) => (options.find((option) => option.key === exportType) || {}).name;




// WEBPACK FOOTER //
// ./src/js/components/documents/filters/export-type-selector.jsx